import { Player } from '@lottiefiles/react-lottie-player';

import animationJson from './urban-line-stars.json?url';

const GeneratingKnowledgeAnimation = () => {
  return <Player autoplay loop src={animationJson} style={{ height: '350px' }} />;
};

export default GeneratingKnowledgeAnimation;
